export const DEFAULT = 'DEFAULT';
import I18n from 'I18n';
export const formatTypeOption = (process = '', operation = '', name) => {
  if (process.length === 0 && operation.length === 0) {
    return name;
  }
  return `${process} ${operation} | ${name}`;
};
export const getGroupAsOption = ({
  preferencesGroup: {
    name,
    id
  }
}) => ({
  text: name,
  value: id
});
export const getGroupOptions = (groups, withUserAccessibleGroups, userAccessibleGroups, defaultTypesText) => [{
  text: defaultTypesText || I18n.text('labels.defaultSubscriptionTypes'),
  value: DEFAULT
}, ...groups.reduce((options, group) => {
  if (!withUserAccessibleGroups || userAccessibleGroups.includes(group.preferencesGroup.id)) {
    return [...options, getGroupAsOption(group)];
  }
  return options;
}, [])];
export const getFilteredTypeOptions = (group, filterDefault, includeInternal, useGDPRFormattedTypes, hideIds = [], disableNonMarketingTypes = false) => group.translatedSubscriptionDefinitions.reduce((options, {
  subscriptionDefinition: {
    id,
    name,
    defaultSubscription,
    process,
    operation,
    internal
  }
}) => {
  const typeIsDefault = !!defaultSubscription;
  const isHidden = hideIds.includes(id);
  const hasNonMarketingProcess = process && process !== 'Marketing';
  const disabled = disableNonMarketingTypes && (internal || hasNonMarketingProcess);
  if (!isHidden && typeIsDefault === filterDefault && (includeInternal || !internal)) {
    return [...options, {
      text: useGDPRFormattedTypes ? formatTypeOption(process, operation, name) : name,
      disabled,
      value: id
    }];
  }
  return options;
}, []);
export const getTypeOptions = (groups, groupId, includeInternal, useGDPRFormattedTypes, hideIds = [], disableNonMarketingTypes = false) => {
  if (groupId === DEFAULT && groups.length) {
    return getFilteredTypeOptions(groups[0], true, includeInternal, useGDPRFormattedTypes, hideIds, disableNonMarketingTypes);
  }
  const group = groups.find(({
    preferencesGroup: {
      id
    }
  }) => groupId === id);
  return group ? getFilteredTypeOptions(group, false, includeInternal, useGDPRFormattedTypes, hideIds, disableNonMarketingTypes) : [];
};
export const getGroupIdFromType = (groups, typeId) => {
  let defaultGroupId;
  const group = groups.find(g => {
    const type = g.translatedSubscriptionDefinitions.find(({
      subscriptionDefinition: {
        id
      }
    }) => id === typeId);
    if (type && type.subscriptionDefinition.defaultSubscription) {
      defaultGroupId = DEFAULT;
    }
    return !!type;
  });
  if (defaultGroupId) {
    return defaultGroupId;
  }
  if (group) {
    return group.preferencesGroup.id;
  }
  return null;
};
export const getTypeById = (groups, typeId) => {
  for (let i = 0; i < groups.length; i++) {
    const type = groups[i].translatedSubscriptionDefinitions.find(({
      subscriptionDefinition: {
        id
      }
    }) => id === typeId);
    if (type) {
      return type.subscriptionDefinition;
    }
  }
  return null;
};
export const getDefaultOptions = (option, hasFilterDuplicates = false) => {
  if (option === 'categories') {
    const marketing = I18n.text('options.marketing');
    const sales = I18n.text('options.sales');
    const marketingKey = hasFilterDuplicates ? 'Marketing' : marketing;
    const salesKey = hasFilterDuplicates ? 'Sales' : sales;
    return {
      options: [{
        text: marketing,
        value: marketingKey
      }, {
        text: sales,
        value: salesKey
      }],
      keys: [marketingKey, salesKey]
    };
  }
  if (option === 'channels') {
    const email = I18n.text('options.email');
    const call = I18n.text('options.call');
    const emailKey = hasFilterDuplicates ? 'Email' : email;
    const callKey = hasFilterDuplicates ? 'Call' : call;
    return {
      options: [{
        text: email,
        value: emailKey
      }, {
        text: call,
        value: callKey
      }],
      keys: [emailKey, callKey]
    };
  }
  return {
    options: [],
    keys: []
  };
};